import { Checkbox, Radio, Form } from "antd"
import { useState, useEffect } from "react"


const CheckBoxForm = (props) => {
    const { values, disabled = false, parent = "", tableLabel = "", inputType="" } = props
    const options = Array.isArray(props.options) ? props.options : []
    const [readOnlyValue, setReadOnlyValue] = useState("")

    let currentValue = values?.[props.id] || []

    useEffect(() => {
            if(disabled) {
                let actualValue = "";
                let valOptions = options.filter(opt => currentValue?.includes(opt.value))
                valOptions = valOptions.map(opt => opt.label)
                if(valOptions.length > 0) { 
                    actualValue = valOptions.join(", ")
                }
                setReadOnlyValue(actualValue || currentValue)
            }
        }, [disabled, options, currentValue])

    return (
        <>
            {
                disabled ? <span>{readOnlyValue}</span>
                : 
                <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
                    <Checkbox.Group options={options} disabled={disabled} value={currentValue} onChange={(values) => { props.handleChange(props.id, values, props.documentId) }} />
                </Form.Item>
            }
        </>
    )
}

export default CheckBoxForm
